import { useState, useEffect, lazy, Suspense } from "react";
import Scene from "@/components/three/Scene";

const About = lazy(() => import("@/components/sections/About"));
const Experience = lazy(() => import("@/components/sections/Experience"));
const Projects = lazy(() => import("@/components/sections/Projects"));
const Skills = lazy(() => import("@/components/sections/Skills"));
const Blog = lazy(() => import("@/components/sections/Blog"));
const Contact = lazy(() => import("@/components/sections/Contact"));

function useDeferredRender(delay: number) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return show;
}

export default function App() {
  const showSections = useDeferredRender(100);

  useEffect(() => {
    const nav = document.getElementById("static-nav");
    if (!nav) return;
    const onScroll = () => {
      if (window.scrollY > 50) {
        nav.classList.add("glass");
      } else {
        nav.classList.remove("glass");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    import("@/utils/customCursor").then((m) => m.init());
    import("@/utils/magneticEffect").then((m) => m.init());
  }, []);

  return (
    <>
      <Scene />
      {showSections && (
        <Suspense fallback={null}>
          <About />
          <Experience />
          <Projects />
          <Skills />
          <Blog />
          <Contact />
        </Suspense>
      )}
    </>
  );
}
